.chart {
  width: 100%;
  min-width: 0;
}
